'use strict';
import angular from 'angular';

angular.module('widget.probe.services', [])

    .factory('WidgetProbeFactory', WidgetProbeFactory);

function WidgetProbeFactory() {

}